import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import RatePlans from './rate-plans';
import RatePlanAddOns from './rate-plan-addons';
import RatePlanPromos from './rate-plan-promos';
import CheckInGuests from './checkin-guests';
import Orders from './orders';
import Insights from './Insights';
const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/rate-promos`} />
      <Route path={`${match.url}/rate-plans`} component={RatePlans} />
      <Route
        path={`${match.url}/rate-plan-addons`}
        component={RatePlanAddOns}
      />
      <Route
        path={`${match.url}/rate-plan-promos`}
        component={RatePlanPromos}
      />
      <Route path={`${match.url}/checkin-guests`} component={CheckInGuests} />
      <Route path={`${match.url}/orders`} component={Orders} />
      <Route path={`${match.url}/insights`} component={Insights} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
